<template>
	<b-container class="mt-5" fluid="lg">
		<b-row>
			<b-col lg="6" offset-lg="3">
				<h2>Login</h2>
				<b-card>
					<b-card-text>You have been logged out.</b-card-text>
				</b-card>
			</b-col>
		</b-row>
	</b-container>
</template>

<style lang="scss">
@import "src/assets/variables";
</style>

<script>
import { USER_LOGOUT } from '../store/actions/user'

export default {
	name: 'Logout',

	data() {
		return {}
	},

	async mounted() {
		await this.$store.dispatch(USER_LOGOUT);
	}
}
</script>
